import { findByType } from "../../../data";
import { useRoadRunnerDashboardAggregatedData } from "./aggregatedData";
import { z } from 'zod';
var ManualTaskStatisticsAttributesSchema = z.object({
  manual_task_statistics: z.array(z.object({
    status: z["enum"](['pending_execution', 'executing', 'done', 'canceled', 'failed', 'snoozed', 'error', 'waiting']),
    count: z.number()
  }))
});
export function useManualTaskStatistics() {
  var _useRoadRunnerDashboa = useRoadRunnerDashboardAggregatedData({
      select: function select(data) {
        var result = findByType(data.included, 'manual_task_statistics');
        if (!result) {
          throw new Error('Could not find manual_task_statistics in the response');
        }
        return ManualTaskStatisticsAttributesSchema.parse(result.attributes).manual_task_statistics;
      }
    }),
    data = _useRoadRunnerDashboa.data;
  if (!data) {
    throw new Error('Missing manual task statistics');
  }
  return {
    statistics: data
  };
}